<template>
    <div class="text-center">
        <component :is="icon"
            class="mx-auto mb-8 h-24 w-24 text-gray-300"
            aria-hidden="true"/>
        <h2 class="text-lg font-semibold leading-6 text-gray-900">{{title }}</h2>
        <p class="mt-1 mb-8 text-base text-gray-500">{{ description }}</p>
        <slot />
    </div>
</template>

<script setup>

const props = defineProps(['title', 'description', 'icon']);
</script>
